import React from "react";
import GlobalNotesList from "./GlobalNotesList";
import "./MyPlannerGlobalNote.scss";

/**
 * Global Notes component for My Planner
 * Uses the GlobalNotesList component in compact mode to display the note icon
 * that matches the original design
 */
const MyPlannerGlobalNote = ({notes, isRefetching}) => {
  return (
    <div className="my-planner-global-note">
      <GlobalNotesList compact={false} globalNotes={notes} isRefetching={isRefetching}/>
    </div>
  );
};

export default MyPlannerGlobalNote;
